import isEmpty from 'lodash/isEmpty'
import React, { ReactNode } from 'react'

import { useTranslation } from '@Globals/Translations'

export const useTranslationMap = () => {
  const { t } = useTranslation()
  const tComponent = (template, components: Record<string, ReactNode>) => {
    const regex = /{{(.*?)}}/g
    const parts = t(template).split(regex)

    return parts.map((part) => {
      if (isEmpty(part)) {
        return null
      }
      if (components[part]) {
        return components[part]
      }
      return (<p key={part}>{part}</p>)
    })
  }

  return { tComponent, t }
}
